import * as yup from "yup";


export const partnerValidationSchema = yup.object({
  // emailAccount: yup.string().required("Veuillez saisir le nom"),
  type: yup.string().trim().required("Veuillez saisir le type de la structure"),
  name: yup.string().trim().required("Veuillez saisir le nom de votre structure"),
  mission: yup.string().trim().required("Veuillez saisir la mission de votre structure"),
  based: yup.string().trim().required("Veuillez saisir la localisation"),
  numberOfSalary: yup.number().min(0, "Doit être supérieur ou égal à 0").required("Veuillez saisir le nombre de salarier"),
  numberOfVolunteers: yup.string().trim().required("Veuillez saisir le nombre de bénévoles"),
  registrationNumber: yup.string().trim().required("Veuillez saisir le Numéro d'enregistrement"),
  webSite: yup.string().trim().required("Veuillez saisir le site web"),
  structureCreationDate: yup.string().trim().required("Veuillez saisir la date de création de la structure"),
  founderName: yup.string().trim().required("Veuillez saisir le nom du fondateur"),
  postalCode: yup.string().trim().required("Veuillez saisir le code postal"),
  country: yup.string().trim().required("Veuillez saisir le pays"),
  city: yup.string().trim().required("Veuillez saisir la ville"),
  department: yup.string().trim().required("Veuillez saisir le département"),
  organisation: yup.string().trim().required("Veuillez choisir l'organisation"),
  // managementBroads: yup.string().trim().required("Veuillez saisir le Conseil d'administration"),
  // managementBroadsMother: yup.string().trim().required("Veuillez saisir le Conseil d'administration parent"),
  // isSubjectLitigationCourtAward: yup.boolean().required("Veuillez saisir le nom"),
  // hasOrganisationDefinedEthicsCompliance: yup.boolean().required("Veuillez cocher le Respecte l'éthique"),
  // isPeoplePoliticallyExposedInStructure: yup.boolean().required("Veuillez saisir le nom"),
  // gouvernmentMemberIsOnManagementBoard: yup.boolean().required("Veuillez saisir le nom"),
  // hasRelationWithGouvernmentOrState: yup.boolean().required("Veuillez saisir le nom"),
  // previousSupportFromFoundation: yup.string().trim().required("Veuillez saisir le Précédent financement"),
 
});
